/**
 * @param {HTMLElement} root
 */
function addBreaksAfterPeriods(root) {
  if (root.dataset.periodBreaksAdded === 'true') return;

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  const nodes = [];

  while (walker.nextNode()) nodes.push(walker.currentNode);

  for (const node of nodes) {
    const text = node.textContent;
    if (!text || !text.includes('.')) continue;

    const fragment = document.createDocumentFragment();
    const parts = text.split('.');

    parts.forEach((part, index) => {
      fragment.append(part);
      if (index < parts.length - 1) {
        fragment.append('.', document.createElement('br'));
      }
    });

    node.replaceWith(fragment);
  }

  root.dataset.periodBreaksAdded = 'true';
}

document.querySelectorAll('.custom-product-description').forEach((description) => {
  if (description instanceof HTMLElement) addBreaksAfterPeriods(description);
});
